<div class="WeatherMain">
    <div class="weatherlabel center">Current Weather</div>
    <div class="weathersection">

        <div class="weatherimage center">
            <i class="fa-thin weathericon" class={{WeatherIconData}}></i>
            <!-- <fa-icon class="fa-thin weathericon help" [icon]="['fat',WeatherIconData]"></fa-icon> -->

        </div>
        <div class="currenttemp center">
            {{WeatherData?.current?.condition?.text}} | {{WeatherData?.current?.temp_f}}&deg;
        </div>
        <div class="highlow center">
            Low {{WeatherData?.forecast?.forecastday[0]?.day?.mintemp_f}}&deg;
        </div>
        <div class="highlow center">
            High {{WeatherData?.forecast?.forecastday[0]?.day?.maxtemp_f}}&deg;
        </div>


    </div>
    <div class="row"></div>

</div>